import * as t from "react/jsx-runtime";
import * as e from "@shared-ui/localization-context";
import * as i from "react";
import * as a from "uitk-react-utils";
import * as s from "uitk-react-date-picker";
import * as n from "@shared-ui/viewport-context";
import * as o from "uitk-react-dialog";
import * as r from "uitk-react-input";
import * as l from "uitk-react-layout-flex";
import * as d from "uitk-react-menu";
import * as c from "uitk-react-button";
import * as h from "uitk-react-icons";
import * as u from "uitk-react-spacing";
import * as m from "uitk-react-scrim";
import * as p from "uitk-react-toolbar";
var k = {
  d: (t, e) => {
    for (var i in e) k.o(e, i) && !k.o(t, i) && Object.defineProperty(t, i, {
      enumerable: !0,
      get: e[i]
    });
  },
  o: (t, e) => Object.prototype.hasOwnProperty.call(t, e)
};
(() => {
  var t;
  if ("string" == typeof import.meta.url && (t = import.meta.url), !t) throw new Error("Automatic publicPath is not supported in this browser");
  t = t.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), k.p = t;
})();
var g = {};
k.d(g, {
  Mt: () => nt,
  TY: () => ot,
  cq: () => $,
  Mk: () => B,
  D8: () => lt,
  Tc: () => tt,
  gu: () => H,
  xL: () => st,
  Lt: () => at,
  dF: () => et,
  OE: () => W,
  al: () => w
});
const D = (S = {
  Fragment: () => t.Fragment,
  jsx: () => t.jsx,
  jsxs: () => t.jsxs
}, y = {}, k.d(y, S), y);
var S, y;
const f = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    useLocalization: () => e.useLocalization
  }),
  x = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    Component: () => i.Component,
    createRef: () => i.createRef,
    useEffect: () => i.useEffect,
    useState: () => i.useState
  }),
  T = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    Level: () => a.Level,
    classNames: () => a.classNames,
    isElementVisible: () => a.isElementVisible,
    liveAnnounce: () => a.liveAnnounce
  }),
  b = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    DatePickerModel: () => s.DatePickerModel,
    UitkCalendar: () => s.UitkCalendar,
    UitkDatePickerInput: () => s.UitkDatePickerInput
  }),
  C = k.p + "./styles/egds-air-flexibility-date-picker-footer-additional-text.css",
  P = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    ViewLarge: () => n.ViewLarge,
    ViewSmall: () => n.ViewSmall,
    Viewport: () => n.Viewport
  }),
  M = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    UitkDialogAnimationType: () => o.UitkDialogAnimationType,
    UitkFullscreenDialog: () => o.UitkFullscreenDialog
  }),
  F = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    UitkFauxInput: () => r.UitkFauxInput,
    UitkTextInput: () => r.UitkTextInput
  }),
  U = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    UitkLayoutFlex: () => l.UitkLayoutFlex,
    UitkLayoutFlexItem: () => l.UitkLayoutFlexItem
  }),
  v = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    PositionType: () => d.PositionType,
    UitkMenu: () => d.UitkMenu,
    UitkMenuContainer: () => d.UitkMenuContainer,
    UitkMenuTrigger: () => d.UitkMenuTrigger
  }),
  E = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    UitkButtonSize: () => c.UitkButtonSize,
    UitkPrimaryButton: () => c.UitkPrimaryButton,
    UitkTertiaryButton: () => c.UitkTertiaryButton
  }),
  j = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    UitkIcon: () => h.UitkIcon,
    UitkIconSize: () => h.UitkIconSize
  }),
  N = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    UitkSpacing: () => u.UitkSpacing
  }),
  L = T.classNames.bind(C);
class I extends x.Component {
  static displayName = "DatePickerFooterAdditionalTextMenuView";
  elementRef;
  constructor(t) {
    super(t), this.elementRef = x.createRef(), this.state = {
      localizedText: {
        cancelButton: () => t.l10n.formatText("datePicker.cancelButton.a11yLabel"),
        datePickerOpened: () => t.l10n.formatText("datePicker.datePickerOpened.liveAnnounce"),
        doneButtonFare: (e, i, a, s) => e <= 1 ? t.l10n.formatText("datePicker.doneButtonFareWithSummary.single.a11yLabel", a, i) : t.l10n.formatText("datePicker.doneButtonFareWithSummary.multiple.a11yLabel", a, s, i),
        clearInstructions: () => t.l10n.formatText("datePicker.clearInstructions.a11yLabel"),
        doneInstructions: () => t.l10n.formatText("datePicker.doneInstructions.a11yLabel"),
        hiddenDoneButton: (e, i, a) => e <= 1 ? t.l10n.formatText("datePicker.doneButtonWithSummary.single.a11yLabel", i) : t.l10n.formatText("datePicker.doneButtonWithSummary.multiple.a11yLabel", i, a)
      }
    }, this.onClickTopStart = this.onClickTopStart.bind(this), this.onClickTopEnd = this.onClickTopEnd.bind(this), this.onSubmitDates = this.onSubmitDates.bind(this), this.onChangeMonth = this.onChangeMonth.bind(this), this.onChangeStartDate = this.onChangeStartDate.bind(this), this.onChangeEndDate = this.onChangeEndDate.bind(this), this.focusOnElement = this.focusOnElement.bind(this), this.hiddenDoneButton = this.hiddenDoneButton.bind(this);
  }
  componentDidMount() {
    const {
        formattedStartSelection: t,
        labels: e,
        preventAutoFocus: i,
        startSelectedMsg: a
      } = this.props,
      {
        localizedText: s
      } = this.state;
    if (this.elementRef && this.elementRef.current) {
      const t = this.elementRef.current.getElementsByTagName("button")[0];
      i || this.focusOnElement(t);
    }
    const n = s.datePickerOpened();
    (0, T.liveAnnounce)(`${n}, \n      ${t} ${e.start} ${a}`);
  }
  shouldComponentUpdate(t) {
    const {
      selection: e
    } = this.props;
    return t && t.holidays && t.holidays.length > 0 && e.configureHolidays(t.holidays), !0;
  }
  onClickTopStart() {
    const {
      onSelectStartMode: t
    } = this.props;
    t();
  }
  onClickTopEnd() {
    const {
      onSelectEndMode: t
    } = this.props;
    t();
  }
  onSubmitDates() {
    const {
      onSubmit: t,
      onDoneButtonClickCB: e
    } = this.props;
    if (e) {
      const {
          selection: t
        } = this.props,
        {
          start: i,
          end: a
        } = t;
      e(i, a);
    } else t();
  }
  onChangeMonth(t) {
    const {
      onChangeMonth: e
    } = this.props;
    e && e(t, !1);
  }
  onChangeStartDate(t) {
    const {
      onChangeStartDate: e
    } = this.props;
    e && e(t, !1);
  }
  onChangeEndDate(t) {
    const {
      onChangeEndDate: e
    } = this.props;
    e && e(t, !1);
  }
  focusOnElement(t) {
    (0, T.isElementVisible)(t) && t.focus();
  }
  hiddenDoneButton() {
    const {
        formattedStartSelection: t,
        formattedEndSelection: e,
        selection: i
      } = this.props,
      {
        localizedText: a
      } = this.state,
      s = i.numberOfNights,
      n = a.hiddenDoneButton(s, t, e);
    return (0, D.jsx)("button", {
      type: "button",
      className: L("is-visually-hidden"),
      onClick: this.onSubmitDates,
      children: n
    });
  }
  render() {
    const {
        buttonText: t,
        clearButtonText: e,
        currentPrice: i,
        datePickerContent: a,
        doneAnalytics: s,
        doubleMonths: n,
        endSelectedMsg: o,
        firstDayOfWeek: r,
        firstValidDate: l,
        footerText: d,
        formattedEndSelection: c,
        formattedStartSelection: h,
        holidays: u,
        labels: m,
        lastValidDate: p,
        nextPageAnalytics: k,
        onClearDates: g,
        previousPageAnalytics: S,
        selection: y,
        selectionClassNames: f,
        singleMode: x,
        startSelectedMsg: T,
        submitDisabled: C,
        updateDatePicker: P,
        useClearDates: M
      } = this.props,
      {
        localizedText: F
      } = this.state,
      v = n ? 2 : 1,
      I = x ? y.start : y.start && y.end;
    return (0, D.jsxs)("div", {
      className: L("uitk-date-picker", "date-picker-menu"),
      ref: this.elementRef,
      children: [(0, D.jsxs)(U.UitkLayoutFlex, {
        alignItems: "center",
        className: L("uitk-date-picker-selection-bar", "uitk-date-picker-selection-bar-top"),
        tag: "section",
        children: [(0, D.jsx)(U.UitkLayoutFlexItem, {
          children: (0, D.jsx)(b.UitkDatePickerInput, {
            cssClassNames: f(!0),
            isDialog: !1,
            onClick: this.onClickTopStart,
            selectionDate: h,
            selectionDateMsg: `${m.start} ${T}`,
            selection: y.start,
            singleMode: x
          })
        }), !x && (0, D.jsx)(U.UitkLayoutFlexItem, {
          className: L("uitk-date-picker-selection-icon"),
          children: (0, D.jsx)(j.UitkIcon, {
            name: "arrow_forward",
            size: j.UitkIconSize.SMALL
          })
        }), !x && (0, D.jsx)(U.UitkLayoutFlexItem, {
          children: (0, D.jsx)(b.UitkDatePickerInput, {
            cssClassNames: f(!1),
            isDialog: !1,
            onClick: this.onClickTopEnd,
            selectionDate: c,
            selectionDateMsg: `${m.end} ${o}`,
            selection: y.end
          })
        }), this.hiddenDoneButton()]
      }), (0, D.jsx)(b.UitkCalendar, {
        buttonText: t,
        datePickerContent: a,
        firstMonth: y.start || l,
        monthsToRender: v,
        isDialog: !1,
        selection: y,
        selectionStart: y.start,
        selectionEnd: y.end,
        startDate: l,
        endDate: p,
        updateDatePicker: P,
        firstDayOfWeek: r,
        singleMode: x,
        nextPageAnalytics: k,
        previousPageAnalytics: S,
        holidays: u,
        onChangeMonth: this.onChangeMonth,
        onChangeStartDate: this.onChangeStartDate,
        onChangeEndDate: this.onChangeEndDate
      }), (0, D.jsxs)(U.UitkLayoutFlex, {
        className: L("uitk-date-picker-menu-footer"),
        children: [!i && (d || y.holidaysConfigured && "" !== y.holidaysName) && [(0, D.jsx)(U.UitkLayoutFlexItem, {
          className: L("uitk-date-picker-footer-text"),
          children: (0, D.jsxs)("div", {
            children: [y.holidaysConfigured && "" !== y.holidaysName && (0, D.jsx)("p", {
              children: y.holidaysName
            }, "holiday"), d && (0, D.jsx)("p", {
              children: d
            }, "legal")]
          })
        }, "0")], d && i && (0, D.jsx)(U.UitkLayoutFlexItem, {
          children: (0, D.jsxs)("div", {
            children: [i && (0, D.jsx)("p", {
              className: L("uitk-date-picker-footer-text-current-price"),
              children: i
            }), d && (0, D.jsx)("p", {
              className: L("uitk-date-picker-footer-text-price-summary"),
              children: d
            }, "legal")]
          })
        }, "1"), (0, D.jsx)(U.UitkLayoutFlexItem, {
          className: L("dialog-done"),
          shrink: 0,
          children: (0, D.jsxs)("div", {
            children: [M && (0, D.jsx)(N.UitkSpacing, {
              margin: {
                inline: "three"
              },
              children: (0, D.jsx)(E.UitkTertiaryButton, {
                "aria-label": F.clearInstructions(),
                disabled: !I,
                onClick: g,
                "data-stid": "clear-date-picker",
                children: e
              })
            }), (0, D.jsx)(E.UitkPrimaryButton, {
              "aria-label": F.doneInstructions(),
              analytics: s,
              onClick: this.onSubmitDates,
              "data-stid": "apply-date-picker",
              disabled: C,
              children: t
            })]
          })
        })]
      })]
    });
  }
}
const B = t => {
  const e = (0, f.useLocalization)();
  return (0, D.jsx)(I, {
    l10n: e,
    ...t
  });
};
B.displayName = "DatePickerFooterAdditionalTextMenuView";
const w = B,
  A = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    UitkScrim: () => m.UitkScrim,
    UitkScrimType: () => m.UitkScrimType
  }),
  V = (t => {
    var e = {};
    return k.d(e, t), e;
  })({
    UitkToolbar: () => p.UitkToolbar,
    UitkToolbarButton: () => p.UitkToolbarButton
  }),
  R = T.classNames.bind(C);
class O extends x.Component {
  static displayName = "DatePickerFooterAdditionalTextDialogView";
  constructor(t) {
    super(t), this.doneButtonRef = x.createRef(), this.state = {
      localizedText: {
        cancelButton: () => t.l10n.formatText("datePicker.cancelButton.a11yLabel"),
        datePickerOpened: () => t.l10n.formatText("datePicker.datePickerOpened.liveAnnounce"),
        doneButtonFare: (e, i, a, s) => e <= 1 ? t.l10n.formatText("datePicker.doneButtonFareWithSummary.single.a11yLabel", a, i) : t.l10n.formatText("datePicker.doneButtonFareWithSummary.multiple.a11yLabel", a, s, i),
        clearInstructions: () => t.l10n.formatText("datePicker.clearInstructions.a11yLabel"),
        doneInstructions: () => t.l10n.formatText("datePicker.doneInstructions.a11yLabel"),
        hiddenDoneButton: (e, i, a) => e <= 1 ? t.l10n.formatText("datePicker.doneButtonWithSummary.single.a11yLabel", i) : t.l10n.formatText("datePicker.doneButtonWithSummary.multiple.a11yLabel", i, a),
        nightSummary: e => t.l10n.formatText("datePicker.nightSummary", e) || (e <= 1 ? t.l10n.formatText("datePicker.nightSummary.single", e) : t.l10n.formatText("datePicker.nightSummary.multiple", e)),
        skipToButton: e => t.l10n.formatText("datePicker.skipToButton", e)
      },
      selection: t.selection
    }, this.onClickTopStart = this.onClickTopStart.bind(this), this.onClickTopEnd = this.onClickTopEnd.bind(this), this.onSubmitClick = this.onSubmitClick.bind(this), this.onDismissClick = this.onDismissClick.bind(this), this.onSelectDate = this.onSelectDate.bind(this), this.internallyUpdateDatePicker = this.internallyUpdateDatePicker.bind(this), this.onChangeStartDate = this.onChangeStartDate.bind(this), this.onChangeEndDate = this.onChangeEndDate.bind(this), this.hiddenDoneButton = this.hiddenDoneButton.bind(this), this.skipToDoneButton = this.skipToDoneButton.bind(this);
  }
  componentDidMount() {
    const {
      localizedText: t
    } = this.state;
    (0, T.liveAnnounce)(t.datePickerOpened(), T.Level.ASSERTIVE);
  }
  shouldComponentUpdate(t) {
    if (t && t.holidays && t.holidays.length > 0) {
      const {
        selection: e
      } = this.props;
      e.configureHolidays(t.holidays);
    }
    return !0;
  }
  onClickTopStart() {
    const {
      onSelectStartMode: t
    } = this.props;
    t(), this.internallyUpdateDatePicker();
  }
  onClickTopEnd() {
    const {
      onSelectEndMode: t
    } = this.props;
    t(), this.internallyUpdateDatePicker();
  }
  onSubmitClick() {
    const {
      onSubmit: t,
      onDoneButtonClickCB: e
    } = this.props;
    if (e) {
      const {
          selection: t
        } = this.props,
        {
          start: i,
          end: a
        } = t;
      e(i, a);
    } else t();
  }
  onDismissClick() {
    const {
      onDismiss: t
    } = this.props;
    t();
  }
  onChangeStartDate(t) {
    const {
      onChangeStartDate: e
    } = this.props;
    e && e(t, !0);
  }
  onChangeEndDate(t) {
    const {
      onChangeEndDate: e
    } = this.props;
    e && e(t, !1);
  }
  onSelectDate() {
    this.internallyUpdateDatePicker();
  }
  doneButtonRef;
  buttonText;
  internallyUpdateDatePicker() {
    this.setState(this.state);
  }
  skipToDoneButton() {
    const {
      localizedText: t
    } = this.state;
    return (0, D.jsx)("button", {
      type: "button",
      className: R("is-visually-hidden", "uitk-date-picker-skip-to-done"),
      onClick: () => {
        this.doneButtonRef && this.doneButtonRef.current && this.doneButtonRef.current.focus();
      },
      children: t.skipToButton(this.buttonText)
    });
  }
  hiddenDoneButton() {
    const {
        formattedStartSelection: t,
        formattedEndSelection: e,
        selection: i
      } = this.props,
      {
        localizedText: a
      } = this.state,
      s = i.numberOfNights,
      n = t,
      o = e,
      r = a.hiddenDoneButton(s, n, o);
    return (0, D.jsx)("button", {
      type: "button",
      className: R("is-visually-hidden"),
      onClick: this.onSubmitClick,
      children: r
    });
  }
  uid = Math.random().toString(36).substring(7);
  renderApplyButton(t, e) {
    const {
        localizedText: i
      } = this.state,
      {
        submitDisabled: a
      } = this.props;
    return (0, D.jsx)(E.UitkPrimaryButton, {
      analytics: t,
      "data-stid": "apply-date-picker",
      disabled: a,
      domRef: this.doneButtonRef,
      onClick: this.onSubmitClick,
      size: E.UitkButtonSize.LARGE,
      "aria-label": i.doneInstructions(),
      className: R("dialog-done-additional"),
      children: e
    });
  }
  render() {
    const {
      buttonText: t,
      clearButtonText: e,
      currentPrice: i,
      footerText: a,
      closeAnalytics: s,
      datePickerContent: n,
      doneAnalytics: o,
      endSelectedMsg: r,
      firstDayOfWeek: l,
      formattedStartSelection: d,
      lastValidDate: c,
      onScrollHandler: h,
      selectionClassNames: u,
      startSelectedMsg: m,
      singleMode: p,
      updateDatePicker: k,
      labels: g,
      l10n: S,
      holidays: y,
      firstValidDate: f,
      useClearDates: x,
      onClearDates: T
    } = this.props;
    this.buttonText = t;
    const {
        selection: C
      } = this.state,
      P = C.start,
      M = C.end,
      F = p ? P : P && M,
      v = P ? S.formatDate(P, {
        dateFormat: "full",
        skeleton: "MMMEd"
      }) : d,
      E = M ? S.formatDate(M, {
        dateFormat: "full",
        skeleton: "MMMEd"
      }) : S.formatText("datePicker.dateInput.endDate.placeholder"),
      {
        localizedText: N
      } = this.state,
      L = !(!C.holidaysConfigured || "" === C.holidaysName),
      I = !(a || C.holidaysConfigured),
      B = R({
        "uitk-calendar-scrim": I
      }),
      w = `clear-date-picker-${this.uid}`;
    return C.holidaysName || (C.holidaysName = []), (0, D.jsxs)(U.UitkLayoutFlex, {
      direction: "column",
      className: R("uitk-date-picker", "date-picker-dialog"),
      children: [(0, D.jsx)(U.UitkLayoutFlexItem, {
        children: (0, D.jsx)(V.UitkToolbar, {
          className: R("uitk-date-picker-toolbar"),
          navigationContent: {
            navIconLabel: N.cancelButton(),
            onClick: this.onDismissClick,
            onClickAnalytics: s
          },
          ...(x && {
            toolbarActionContent: (0, D.jsx)(V.UitkToolbarButton, {
              "aria-label": N.clearInstructions(),
              buttonId: w,
              disabled: !F,
              onClick: T,
              children: e
            })
          }),
          children: (0, D.jsxs)(U.UitkLayoutFlex, {
            alignItems: "center",
            className: R("uitk-date-picker-selection-bar", "uitk-date-picker-selection-bar-top"),
            tag: "section",
            children: [(0, D.jsx)(U.UitkLayoutFlexItem, {
              children: (0, D.jsx)(b.UitkDatePickerInput, {
                cssClassNames: u(!0),
                isDialog: !0,
                onClick: this.onClickTopStart,
                selectionDate: v,
                selectionDateMsg: `${g.start} ${m}`,
                selection: C.start,
                singleMode: p
              })
            }), !p && (0, D.jsxs)(D.Fragment, {
              children: [(0, D.jsx)(U.UitkLayoutFlexItem, {
                className: R("uitk-date-picker-selection-icon"),
                children: (0, D.jsx)(j.UitkIcon, {
                  name: "arrow_forward",
                  size: j.UitkIconSize.SMALL
                })
              }), (0, D.jsx)(U.UitkLayoutFlexItem, {
                children: (0, D.jsx)(b.UitkDatePickerInput, {
                  cssClassNames: u(!1),
                  isDialog: !0,
                  onClick: this.onClickTopEnd,
                  selectionDate: E,
                  selectionDateMsg: `${g.end} ${r}`,
                  selection: C.end
                })
              })]
            }), this.hiddenDoneButton()]
          })
        })
      }), (0, D.jsx)(U.UitkLayoutFlexItem, {
        children: (0, D.jsx)(b.UitkCalendar, {
          buttonText: t,
          className: B,
          firstMonth: f,
          skipToDoneButton: this.skipToDoneButton,
          datePickerContent: n,
          isDialog: !0,
          selection: C,
          selectionStart: C.start,
          selectionEnd: C.end,
          startDate: f,
          endDate: c,
          updateDatePicker: k,
          firstDayOfWeek: l,
          onSelectDate: this.onSelectDate,
          singleMode: p,
          holidays: y,
          onChangeStartDate: this.onChangeStartDate,
          onChangeEndDate: this.onChangeEndDate,
          onScrollHandler: h
        })
      }), (0, D.jsxs)(U.UitkLayoutFlexItem, {
        children: [I && (0, D.jsx)(A.UitkScrim, {
          type: A.UitkScrimType.BUTTON,
          className: R("uitk-date-picker-footer"),
          children: this.renderApplyButton(o, t)
        }), !I && (0, D.jsxs)("div", {
          className: R("uitk-date-picker-footer-opaque-additional"),
          children: [L && (0, D.jsx)("div", {
            className: R("uitk-date-picker-footer-text"),
            children: (0, D.jsx)("p", {
              children: C.holidaysName
            })
          }), !i && a && (0, D.jsx)("p", {
            className: R("uitk-date-picker-footer-text", {
              "uitk-date-picker-footer-text-center": !L
            }),
            children: a
          }), a && i && (0, D.jsx)(U.UitkLayoutFlexItem, {
            className: R("uitk-date-picker-footer-summary"),
            children: (0, D.jsxs)("div", {
              children: [i && (0, D.jsx)("p", {
                className: R("uitk-date-picker-footer-text-current-price"),
                children: i
              }), a && (0, D.jsx)("p", {
                className: R("uitk-date-picker-footer-text-price-summary"),
                children: a
              }, "legal")]
            })
          }, "1"), this.renderApplyButton(o, t)]
        })]
      })]
    });
  }
}
const $ = t => {
  const e = (0, f.useLocalization)();
  return (0, D.jsx)(O, {
    l10n: e,
    ...t
  });
};
$.displayName = "DatePickerFooterAdditionalTextDialogView";
const W = $,
  z = T.classNames.bind(C);
var H;
!function (t) {
  t.YMD = "yyyy-MM-dd";
}(H || (H = {}));
const _ = t => ({
    ...t.datePickerProps,
    onChangeEndDate: t.onChangeEndDate,
    onChangeMonth: t.onChangeMonth,
    onChangeStartDate: t.onChangeStartDate,
    onClearDates: t.onClearDates,
    onDismiss: t.onDismiss,
    onScrollHandler: t.onScrollHandler,
    onSubmit: t.onSubmit,
    preventAutoFocus: t.preventAutoFocus,
    singleMode: t.singleMode && !t.useSingleTrigger,
    useClearDates: t.useClearDates,
    useSingleTrigger: t.useSingleTrigger
  }),
  Y = (t, e, i, a) => {
    const s = {
        dateFormat: "medium",
        skeleton: a ?? "MMMd"
      },
      n = {
        dateFormat: "iso-date",
        raw: i
      },
      {
        value: o,
        placeholder: r
      } = e;
    return {
      value: t.formatDate(o, n),
      formattedBtnText: o ? t.formatDate(o, s) : r,
      accessibleFormattedText: o ? t.formatDate(o, s) : r,
      label: (0, D.jsx)("span", {
        "aria-hidden": "true",
        children: e.label
      })
    };
  },
  q = t => {
    const {
      updateViewport: e
    } = t;
    (0, x.useEffect)(() => {
      e && e(!0);
    }, []);
    const i = _(t);
    return (0, D.jsx)(M.UitkFullscreenDialog, {
      dialogShow: !0,
      animation: M.UitkDialogAnimationType.SLIDEUP,
      children: (0, D.jsx)($, {
        ...i
      })
    });
  },
  G = t => {
    const {
      updateViewport: e
    } = t;
    (0, x.useEffect)(() => {
      e && e(!1);
    }, []);
    const i = _(t);
    return (0, D.jsx)(B, {
      ...i
    });
  };
q.displayName = "CustomTriggerDialog";
const J = t => {
  const {
      dateFormat: e,
      endProps: i,
      l10n: a,
      mediumDateFormatProp: s,
      onChange: n,
      routerLinkWrapper: o,
      openDatePicker: r
    } = t,
    [l, d] = (0, x.useState)(!1);
  if ((0, x.useEffect)(() => {
    d(!0);
  }, []), !i) return null;
  const {
      value: c,
      accessibleFormattedText: h,
      formattedBtnText: u,
      label: m
    } = Y(a, i, e, s),
    p = `${i.label} ${h}`,
    k = z({
      "is-hidden": l
    });
  return (0, D.jsx)(F.UitkTextInput, {
    id: i.id,
    name: i.name,
    className: k,
    label: m,
    placeholder: i.placeholder,
    value: c,
    onChange: n,
    "data-stid": "input-date",
    icon: "today",
    invalid: i.invalid,
    children: l && o && o((0, D.jsx)(F.UitkFauxInput, {
      "aria-label": p,
      className: z("uitk-form-field-trigger"),
      domRef: i.domRef,
      "data-name": i.name,
      id: `${i.id}-btn`,
      "data-stid": "open-date-picker",
      type: "button",
      onClick: () => {
        r(i.dateType);
      },
      analytics: i.analytics,
      children: u
    }))
  });
};
J.displayName = "DialogEndDateField";
const K = t => {
  const {
      updateViewport: e
    } = t,
    [i, a] = (0, x.useState)(!1);
  (0, x.useEffect)(() => {
    a(!0), e && e(!0);
  }, []);
  const {
      dateFieldWrapperClasses: s,
      dateFormat: n,
      dialogWrapper: o,
      l10n: r,
      mediumDateFormatProp: l,
      onChange: d,
      routerLinkWrapper: c,
      showDatePicker: h,
      singleMode: u,
      space: m,
      stacked: p,
      startProps: k,
      endProps: g,
      triggeredField: S,
      useSingleTrigger: y,
      openDatePicker: f
    } = t,
    {
      value: T,
      formattedBtnText: b,
      accessibleFormattedText: C,
      label: P
    } = Y(r, k, n, l);
  let v = T,
    E = b,
    j = `${k.label}`;
  if (C && (j += ` ${C}`), y && g) {
    const {
      value: t,
      formattedBtnText: e,
      accessibleFormattedText: i
    } = Y(r, g, n, l);
    t && (v += ` - ${t}`), e && (E += ` - ${e}`), i && (j = `${k.label} ${r.formatText("datepicker.buttonLabel.endAccessibleFormattedText", C, i)}`);
  }
  const N = p && !u && !y,
    L = z({
      "uitk-date-field-wrapper": !N
    }),
    I = N ? "column" : "row",
    B = z("egds-team-date-picker-with-footer-additional-text", {
      [`${s}`]: s
    }, "uitk-date-fields-wrapper"),
    w = _(t),
    A = z({
      "is-hidden": i
    });
  return (0, D.jsx)(U.UitkLayoutFlexItem, {
    className: B,
    grow: 1,
    children: (0, D.jsxs)(U.UitkLayoutFlex, {
      className: z("uitk-date-fields"),
      direction: I,
      space: m,
      children: [h && S && o((0, D.jsx)(M.UitkFullscreenDialog, {
        dialogShow: !0,
        animation: M.UitkDialogAnimationType.SLIDEUP,
        children: (0, D.jsx)($, {
          ...w
        })
      }), S), (0, D.jsx)(U.UitkLayoutFlexItem, {
        className: L,
        grow: 1,
        minWidth: "zero",
        maxWidth: u || y || p ? void 0 : "half_width",
        children: (0, D.jsx)("div", {
          children: (0, D.jsx)(F.UitkTextInput, {
            id: k.id,
            name: k.name,
            className: A,
            label: P,
            placeholder: k.placeholder,
            value: v,
            onChange: d,
            "data-stid": "input-date",
            icon: "today",
            invalid: k.invalid,
            children: i && c && c((0, D.jsx)(F.UitkFauxInput, {
              "aria-label": j,
              className: z("uitk-form-field-trigger"),
              domRef: k.domRef,
              "data-name": k.name,
              id: `${k.id}-btn`,
              "data-stid": "open-date-picker",
              type: "button",
              onClick: () => {
                f(k.dateType);
              },
              analytics: k.analytics,
              children: E
            }))
          })
        })
      }), !u && !y && (0, D.jsx)(U.UitkLayoutFlexItem, {
        className: L,
        grow: 1,
        minWidth: "zero",
        maxWidth: p ? void 0 : "half_width",
        children: (0, D.jsx)("div", {
          children: (0, D.jsx)(J, {
            ...t
          })
        })
      })]
    })
  });
};
K.displayName = "DialogDateFields";
const Q = t => {
  const {
      dateFormat: e,
      mediumDateFormatProp: i,
      endProps: a,
      l10n: s,
      onChange: n,
      onSubmit: o,
      showDatePicker: r,
      triggeredField: l,
      openDatePicker: d
    } = t,
    [c, h] = (0, x.useState)(!1);
  if ((0, x.useEffect)(() => {
    h(!0);
  }, []), !a) return null;
  const {
      value: u,
      formattedBtnText: m,
      accessibleFormattedText: p,
      label: k
    } = Y(s, a, e, i),
    g = `${a.label} ${p}`,
    S = c && r,
    y = z("uitk-date-picker-menu-container", {
      "uitk-date-picker-menu-container-single": !a.doubleMonths,
      "uitk-date-picker-menu-container-double": a.doubleMonths
    }),
    f = _(t),
    T = z({
      "is-hidden": c
    });
  return (0, D.jsxs)(v.UitkMenu, {
    isOpen: S,
    className: z("uitk-date-picker-menu"),
    onDismiss: o,
    children: [(0, D.jsx)(v.UitkMenuTrigger, {
      children: (0, D.jsx)(F.UitkTextInput, {
        className: T,
        id: a.id,
        name: a.name,
        label: k,
        placeholder: a.placeholder,
        value: u,
        onChange: n,
        "data-stid": "input-date",
        icon: "today",
        invalid: a.invalid,
        children: c && (0, D.jsx)(F.UitkFauxInput, {
          "aria-label": g,
          className: z("uitk-form-field-trigger"),
          domRef: a.domRef,
          "data-name": a.name,
          id: `${a.id}-btn`,
          "data-stid": "open-date-picker",
          type: "button",
          onClick: () => {
            d(a.dateType);
          },
          analytics: a.analytics,
          children: m
        })
      })
    }), r && "end" === l && (0, D.jsx)(v.UitkMenuContainer, {
      position: v.PositionType.LEFT,
      className: y,
      autoPosition: !0,
      children: (0, D.jsx)(B, {
        ...f
      })
    })]
  });
};
Q.displayName = "MenuEndDateField";
const X = t => {
  const {
      updateViewport: e,
      openDatePicker: i
    } = t,
    [a, s] = (0, x.useState)(!1);
  (0, x.useEffect)(() => {
    s(!0), e && e(!1);
  }, []);
  const {
      dateFieldWrapperClasses: n,
      dateFormat: o,
      l10n: r,
      mediumDateFormatProp: l,
      onChange: d,
      onSubmit: c,
      showDatePicker: h,
      singleMode: u,
      space: m,
      stacked: p,
      startProps: k,
      endProps: g,
      triggeredField: S,
      useSingleTrigger: y
    } = t,
    {
      value: f,
      formattedBtnText: T,
      accessibleFormattedText: b,
      label: C
    } = Y(r, k, o, l);
  let P = f,
    M = T,
    E = `${k.label}`;
  if (b && (E += ` ${b}`), y && g) {
    const {
      value: t,
      formattedBtnText: e,
      accessibleFormattedText: i
    } = Y(r, g, o, l);
    t && (P += ` - ${t}`), e && (M += ` - ${e}`), i && (E = `${k.label} ${r.formatText("datepicker.buttonLabel.endAccessibleFormattedText", b, i)}`);
  }
  const j = h,
    N = z("uitk-date-picker-menu-container", {
      "uitk-date-picker-menu-container-single": !k.doubleMonths,
      "uitk-date-picker-menu-container-double": k.doubleMonths
    }),
    L = _(t),
    I = p && !u && !y,
    w = z({
      "uitk-date-field-wrapper": !I
    }),
    A = I ? "column" : "row",
    V = z("egds-team-date-picker-with-footer-additional-text", {
      [`${n}`]: n
    }, "uitk-date-fields-wrapper"),
    R = z({
      "is-hidden": a
    });
  return (0, D.jsx)(U.UitkLayoutFlexItem, {
    className: V,
    grow: 1,
    children: (0, D.jsxs)(U.UitkLayoutFlex, {
      className: z("uitk-date-fields"),
      space: m,
      direction: A,
      children: [(0, D.jsx)(U.UitkLayoutFlexItem, {
        className: w,
        grow: 1,
        minWidth: "zero",
        maxWidth: u || y || p ? void 0 : "half_width",
        children: (0, D.jsx)("div", {
          children: (0, D.jsxs)(v.UitkMenu, {
            isOpen: j,
            className: z("uitk-date-picker-menu"),
            onDismiss: c,
            children: [(0, D.jsx)(v.UitkMenuTrigger, {
              children: (0, D.jsx)(F.UitkTextInput, {
                className: R,
                id: k.id,
                name: k.name,
                label: C,
                placeholder: k.placeholder,
                value: P,
                onChange: d,
                "data-stid": "input-date",
                icon: "today",
                invalid: k.invalid,
                children: a && (0, D.jsx)(F.UitkFauxInput, {
                  "aria-label": E,
                  className: z("uitk-form-field-trigger"),
                  domRef: k.domRef,
                  "data-name": k.name,
                  id: `${k.id}-btn`,
                  "data-stid": "open-date-picker",
                  type: "button",
                  onClick: () => {
                    i(k.dateType);
                  },
                  analytics: k.analytics,
                  children: M
                })
              })
            }), h && "start" === S && (0, D.jsx)(v.UitkMenuContainer, {
              position: v.PositionType.LEFT,
              className: N,
              autoPosition: !0,
              children: (0, D.jsx)(B, {
                ...L
              })
            })]
          })
        })
      }), !u && !y && (0, D.jsx)(U.UitkLayoutFlexItem, {
        className: w,
        grow: 1,
        minWidth: "zero",
        maxWidth: p ? void 0 : "half_width",
        children: (0, D.jsx)("div", {
          children: (0, D.jsx)(Q, {
            ...t
          })
        })
      })]
    })
  });
};
X.displayName = "MenuDateFields";
class Z extends x.Component {
  static displayName = "UitkDateField";
  static defaultProps = {
    dateFormat: H.YMD,
    space: "three",
    triggeredField: "start"
  };
  render() {
    const {
      useCustomTrigger: t,
      datePickerProps: e
    } = this.props;
    if (t) switch (e.renderType) {
      case st.DIALOG:
        return (0, D.jsx)(q, {
          ...this.props
        });
      case st.MENU:
        return (0, D.jsx)(G, {
          ...this.props
        });
      default:
        return (0, D.jsxs)(P.Viewport, {
          children: [(0, D.jsx)(P.ViewSmall, {
            children: (0, D.jsx)(q, {
              ...this.props
            })
          }), (0, D.jsx)(P.ViewLarge, {
            children: (0, D.jsx)(G, {
              ...this.props
            })
          })]
        });
    }
    switch (e.renderType) {
      case st.DIALOG:
        return (0, D.jsx)(K, {
          ...this.props
        });
      case st.MENU:
        return (0, D.jsx)(X, {
          ...this.props
        });
      default:
        return (0, D.jsxs)(P.Viewport, {
          children: [(0, D.jsx)(P.ViewSmall, {
            children: (0, D.jsx)(K, {
              ...this.props
            })
          }), (0, D.jsx)(P.ViewLarge, {
            children: (0, D.jsx)(X, {
              ...this.props
            })
          })]
        });
    }
  }
}
const tt = t => {
  const e = (0, f.useLocalization)();
  return (0, D.jsx)(Z, {
    l10n: e,
    ...t
  });
};
tt.displayName = "UitkDateField";
const et = tt,
  it = T.classNames.bind(C);
var at, st;
!function (t) {
  t.START = "start", t.END = "end", t.NONE = "none";
}(at || (at = {})), function (t) {
  t.DIALOG = "dialog", t.MENU = "menu";
}(st || (st = {}));
class nt extends x.Component {
  static defaultProps = {
    daysBookableInAdvance: 500,
    midnightBookingOffset: 4,
    preventAutoFocus: !1,
    singleMode: !1
  };
  constructor(t) {
    super(t);
    const e = this.setInitialDates(),
      i = new b.DatePickerModel(e.lastValidDate, t.singleDateSelect);
    let a;
    a = t.triggeredSelector ? t.triggeredSelector : t.dateFieldProps.showDatePicker ? at.START : "", this.startDomRef = t.startDateRef ? t.startDateRef : x.createRef(), this.endDomRef = t.endDateRef ? t.endDateRef : x.createRef(), this.state = {
      localizedText: {
        checkInInstructions: () => t.l10n.formatText("datePicker.fromDateInstructions.a11yLabel"),
        checkOutInstructions: () => t.l10n.formatText("datePicker.toDateInstructions.a11yLabel"),
        dateFieldSelected: () => t.l10n.formatText("datePicker.selectedDateField.allyLabel"),
        doneHeader: () => t.l10n.formatText("datePicker.doneHeader"),
        clearHeader: () => t.l10n.formatText("datePicker.clearHeader"),
        selectEndDate: () => t.l10n.formatText("datePicker.dateInput.endDate.placeholder"),
        selectStartDate: () => t.l10n.formatText("datePicker.dateInput.startDate.placeholder"),
        clearedDates: () => t.l10n.formatText("datepicker.cleared.dates")
      },
      name: a,
      selection: i
    }, this.getDatePickerProps = this.getDatePickerProps.bind(this), this.onSubmit = this.onSubmit.bind(this), this.onClearDates = this.onClearDates.bind(this), this.onDismiss = this.onDismiss.bind(this), this.onSelectStartMode = this.onSelectStartMode.bind(this), this.onSelectEndMode = this.onSelectEndMode.bind(this), this.openDatePicker = this.openDatePicker.bind(this), this.selectionClassNames = this.selectionClassNames.bind(this), this.setInitialDates = this.setInitialDates.bind(this), this.updateDatePicker = this.updateDatePicker.bind(this), this.updateViewport = this.updateViewport.bind(this);
  }
  UNSAFE_componentWillMount() {
    this.updateStateWithProps(this.props);
  }
  componentDidMount() {
    const {
      props: t
    } = this;
    t.onMountCB && t.onMountCB(this.startDomRef, this.endDomRef);
  }
  UNSAFE_componentWillReceiveProps(t) {
    const {
      startDate: e,
      endDate: i,
      validStartDate: a
    } = this.props;
    t.startDate === e && t.endDate === i || (this.preselectedStart = t.startDate, this.preselectedEnd = t.endDate), t.validStartDate !== a && this.setFirstValidDate(t), this.updateStateWithProps(t);
  }
  componentDidUpdate(t) {
    const {
        dateFieldProps: e,
        daysBookableInAdvance: i
      } = this.props,
      {
        selection: a
      } = this.state;
    t.daysBookableInAdvance !== i && (this.lastValidDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() + i, this.today.getDate()), a.lastValidEndDate = this.lastValidDate), !t.dateFieldProps.showDatePicker && e.showDatePicker && (this.isOpenInternallyDriven ? this.isOpenInternallyDriven = void 0 : this.openDatePicker(at.START, !1));
  }
  onSubmit() {
    const {
        l10n: t,
        onSubmitCB: e
      } = this.props,
      {
        name: i,
        selection: a
      } = this.state,
      {
        start: s,
        end: n
      } = a;
    this.resetLiveAnnounce(), this.updateDatePicker(), this.preselectedEnd = t.formatDate(n, {
      dateFormat: "iso-date",
      raw: "yyyy-MM-dd"
    }), this.preselectedStart = t.formatDate(s, {
      dateFormat: "iso-date",
      raw: "yyyy-MM-dd"
    }), this.focusOnTrigger(i), e && e(s, n, this.isDialog);
  }
  onClearDates() {
    const {
      onClearDatesCB: t
    } = this.props;
    this.clearDatePicker(), t && t();
  }
  onDismiss(t) {
    const {
        onDismissCB: e
      } = this.props,
      {
        name: i,
        selection: a
      } = this.state;
    a.start = null, a.end = null, this.updateDatePicker(), this.resetLiveAnnounce(), this.focusOnTrigger(i), e && e(this.isDialog, t);
  }
  onSelectStartMode(t) {
    const {
        onSelectStartModeCB: e
      } = this.props,
      {
        localizedText: i,
        selection: a
      } = this.state;
    a.setCurrentTrigger("start"), (0, T.liveAnnounce)(i.checkInInstructions(), T.Level.POLITE), e && e(), t || this.updateDatePicker();
  }
  onSelectEndMode(t) {
    const {
        onSelectEndModeCB: e
      } = this.props,
      {
        localizedText: i,
        selection: a
      } = this.state;
    a.setCurrentTrigger("end"), (0, T.liveAnnounce)(i.checkOutInstructions(), T.Level.POLITE), e && e(), t || this.updateDatePicker();
  }
  getDatePickerProps() {
    const {
        analytics: t,
        buttonText: e,
        clearButtonText: i,
        currentPrice: a,
        dateFieldProps: s,
        datePickerContent: n,
        doubleMonths: o,
        endSelectionPlaceholder: r,
        firstDayOfWeek: l,
        footerText: d,
        holidays: c,
        l10n: h,
        onDoneButtonClickCB: u,
        renderType: m,
        singleMode: p,
        startSelectionPlaceholder: k,
        submitDisabled: g
      } = this.props,
      {
        localizedText: D,
        selection: S
      } = this.state,
      y = S.start,
      f = S.end,
      x = k || D.selectStartDate(),
      T = r || D.selectEndDate(),
      b = y ? h.formatDate(y, {
        dateFormat: "full",
        skeleton: "MMMEd"
      }) : x,
      C = f ? h.formatDate(f, {
        dateFormat: "full",
        skeleton: "MMMEd"
      }) : T,
      P = t || {},
      {
        closeAnalytics: M,
        doneAnalytics: F,
        nextPageAnalytics: U,
        previousPageAnalytics: v
      } = P,
      E = e || D.doneHeader(),
      j = i || D.clearHeader(),
      N = this.isSelected(!0) ? D.dateFieldSelected() : "";
    return {
      buttonText: E,
      clearButtonText: j,
      closeAnalytics: M,
      currentPrice: a,
      datePickerContent: n,
      doneAnalytics: F,
      doubleMonths: o,
      endSelectedMsg: this.isSelected(!1) ? D.dateFieldSelected() : "",
      firstDayOfWeek: l,
      firstValidDate: this.firstValidDate,
      footerText: d,
      formattedEndSelection: C,
      formattedStartSelection: b,
      holidays: c,
      labels: {
        end: s.endLabel,
        start: s.startLabel
      },
      lastValidDate: this.lastValidDate,
      nextPageAnalytics: U,
      onDoneButtonClickCB: u,
      onSelectEndMode: this.onSelectEndMode,
      onSelectStartMode: this.onSelectStartMode,
      previousPageAnalytics: v,
      renderType: m,
      selection: S,
      selectionClassNames: this.selectionClassNames,
      singleMode: p,
      startSelectedMsg: N,
      submitDisabled: g,
      today: this.today,
      updateDatePicker: this.updateDatePicker
    };
  }
  setFirstValidDate(t) {
    if (this.firstValidDate = this.today, t.validStartDate) {
      try {
        this.firstValidDate = t.l10n.parseLocalDateString(t.validStartDate, {
          dateFormat: "iso",
          raw: "yyyy-MM-dd"
        });
      } catch (t) {
        console.error(t);
      }
      this.firstValidDate < this.today && (this.firstValidDate = this.today);
    }
  }
  setInitialDates() {
    const {
      cutoffDate: t,
      daysBookableInAdvance: e,
      endDate: i,
      l10n: a,
      midnightBookingOffset: s,
      singleMode: n,
      startDate: o
    } = this.props;
    if (this.today = new Date(), this.today.setHours(12), this.today.setMinutes(0), this.today.setSeconds(0), this.today.setMilliseconds(0), this.lastValidDate = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() + e), t) try {
      this.lastValidDate = a.parseLocalDateString(t, {
        dateFormat: "iso",
        raw: "yyyy-MM-dd"
      });
    } catch (t) {
      console.error(t);
    }
    return this.setFirstValidDate(this.props), this.tomorrow = new Date(), this.tomorrow.setDate(this.firstValidDate.getDate() + 1), s && new Date().getHours() < s && this.today.setDate(this.today.getDate() - 1), i && !n && (this.preselectedEnd = i), o && (this.preselectedStart = o), {
      firstValidDate: this.firstValidDate,
      lastValidDate: this.lastValidDate
    };
  }
  today;
  tomorrow;
  preselectedEnd;
  preselectedStart;
  startDomRef;
  endDomRef;
  lastValidDate;
  firstValidDate;
  isDialog;
  isOpenInternallyDriven;
  updateViewport(t) {
    this.isDialog = t;
  }
  updateStateWithProps(t) {
    const {
        l10n: e,
        singleMode: i,
        triggeredSelector: a
      } = t,
      {
        selection: s
      } = this.state;
    if (this.preselectedStart) {
      let t = this.firstValidDate;
      try {
        t = e.parseLocalDateString(this.preselectedStart, {
          dateFormat: "iso",
          raw: "yyyy-MM-dd"
        });
      } catch (t) {
        console.error(t);
      }
      t.setHours(12), t >= this.firstValidDate ? s.start = t : (this.clearDatePicker(), this.preselectedStart = null, this.preselectedEnd = null);
    }
    if (this.preselectedEnd) {
      let t = this.tomorrow;
      try {
        t = e.parseLocalDateString(this.preselectedEnd, {
          dateFormat: "iso",
          raw: "yyyy-MM-dd"
        });
      } catch (t) {
        console.error(t);
      }
      t.setHours(12), s.end = t;
    }
    this.preselectedStart || this.preselectedEnd || (s.start = null, s.end = null), i && delete s.end, a && s.setCurrentTrigger(a);
  }
  resetLiveAnnounce() {
    (0, T.liveAnnounce)("", T.Level.POLITE);
  }
  openDatePicker(t, e = !0) {
    const {
      props: i
    } = this;
    this.isOpenInternallyDriven = e, "start" === t ? this.onSelectStartMode(!0) : this.onSelectEndMode(!0), this.setState({
      name: t
    }), i.onOpenCB && i.onOpenCB(t, this.isDialog);
  }
  isSelected(t) {
    const {
      selection: e
    } = this.state;
    return t && e.isSelectingStart || !t && e.isSelectingEnd || t && !e.isSelectingStart && !e.isSelectingEnd;
  }
  selectionClassNames(t) {
    return it("uitk-date-picker-top-bar-selection", {
      selected: this.isSelected(t)
    });
  }
  createCustomEvent(t, e) {
    const i = new CustomEvent("change"),
      a = document.createElement("input");
    a.value = t, a.addEventListener("change", t => {
      e(t);
    }), a.dispatchEvent(i);
  }
  updateDatePicker() {
    const {
        localizedText: t,
        selection: e
      } = this.state,
      {
        onStartDateResultSelection: i,
        onEndDateResultSelection: a
      } = this.props;
    i && this.createCustomEvent(e.start, i), a && this.createCustomEvent(e.end, a), this.setState({
      localizedText: t,
      selection: e
    });
  }
  clearDatePicker() {
    const {
      localizedText: t,
      selection: e
    } = this.state;
    e.start = null, e.end = null, (0, T.liveAnnounce)(t.clearedDates()), this.updateDatePicker();
  }
  focusOnTrigger(t) {
    const e = "start" === t ? this.startDomRef : this.endDomRef;
    (0, T.isElementVisible)(e.current) && e?.current?.focus();
  }
  render() {
    const {
        dialogWrapper: t,
        dateFieldProps: e,
        doubleMonths: i,
        onChangeEndDateCB: a,
        onChangeMonthCB: s,
        onChangeStartDateCB: n,
        onScrollHandler: o,
        preventAutoFocus: r,
        singleMode: l,
        triggeredSelector: d,
        useClearDates: c,
        useSingleTrigger: h
      } = this.props,
      {
        name: u,
        selection: m
      } = this.state,
      {
        dateFieldWrapperClasses: p,
        dateFormat: k,
        endAnalytics: g,
        endId: S,
        endInvalid: y,
        endLabel: f,
        endName: x,
        endPlaceholder: T,
        mediumDateFormatProp: b,
        onChange: C,
        useCustomTrigger: P,
        routerLinkWrapper: M,
        showDatePicker: F,
        space: U,
        stacked: v,
        startAnalytics: E,
        startId: j,
        startInvalid: N,
        startLabel: L,
        startName: I,
        startPlaceholder: B
      } = e;
    let w, A;
    A = t || (t => (0, D.jsx)("div", {
      id: "date-picker",
      className: it("uitk-dialog-layer", "uitk-dialog-layer-responsive"),
      children: t
    }));
    const V = {
        dateFieldWrapperClasses: p,
        dateFormat: k,
        dialogWrapper: A,
        mediumDateFormatProp: b,
        onChange: C,
        onChangeEndDate: a,
        onChangeMonth: s,
        onChangeStartDate: n,
        onClearDates: this.onClearDates,
        onDismiss: this.onDismiss,
        onScrollHandler: o,
        onSubmit: this.onSubmit,
        openDatePicker: this.openDatePicker,
        preventAutoFocus: r,
        routerLinkWrapper: M,
        showDatePicker: F,
        singleMode: l,
        space: U,
        stacked: v,
        triggeredField: d || u,
        useCustomTrigger: P,
        useClearDates: c,
        useSingleTrigger: h
      },
      R = {
        datePickerProps: this.getDatePickerProps(),
        endProps: w,
        startProps: {
          analytics: E,
          dateType: at.START,
          domRef: this.startDomRef,
          doubleMonths: i,
          id: j,
          invalid: N,
          label: L,
          name: I || "startDate",
          placeholder: B,
          value: m.start
        },
        updateViewport: this.updateViewport,
        ...V
      };
    return l || (w = {
      analytics: g,
      dateType: at.END,
      domRef: this.endDomRef,
      doubleMonths: i,
      id: S,
      invalid: y,
      label: f,
      name: x || "endDate",
      placeholder: T,
      value: m.end
    }, R.endProps = w), (0, D.jsx)(tt, {
      ...R
    });
  }
}
const ot = t => {
  const e = (0, f.useLocalization)();
  return (0, D.jsx)(nt, {
    l10n: e,
    ...t
  });
};
ot.displayName = "DatePickerFooterAdditionalText";
const rt = 864e5;
class lt {
  isSelectingStart = !1;
  isSelectingEnd = !1;
  start;
  end;
  lastValidEndDate;
  singleDateSelect = !1;
  holidays;
  holidaysName;
  holidaysConfigured;
  dayHolidays;
  isNotFirstTimeSameLength;
  constructor(t, e) {
    this.lastValidEndDate = t, this.singleDateSelect = e, this.dayHolidays = {}, this.isNotFirstTimeSameLength = !1;
  }
  get numberOfNights() {
    return this.start && this.end ? Math.round(Math.abs((this.end.getTime() - this.start.getTime()) / rt)) : 0;
  }
  isDateSelected(t) {
    return !(!this.start || !this.end) && (this.setHolidaysSelection(), t.getTime() >= this.start.getTime() && t.getTime() <= this.end.getTime());
  }
  dateSelected(t) {
    this.start || this.end ? this.start && this.end ? this.isSelectingStart ? this.selectStartWithSameLengthOfStay(t) : this.isSelectingEnd ? this.selectEndWithAvailableStart(t) : this.resetAndSetStart(t) : this.start && !this.end ? this.isSelectingStart ? (this.start = t, this.setCurrentTrigger("end")) : this.isSelectingEnd ? this.selectEndWithAvailableStart(t) : this.resetAndSetStart(t) : this.isSelectingStart ? this.selectStartWithAvailableEnd(t) : this.isSelectingEnd ? (this.end = t, this.setCurrentTrigger("start")) : this.resetAndSetStart(t) : this.isSelectingStart ? (this.start = t, this.setCurrentTrigger("end")) : this.isSelectingEnd ? (this.end = t, this.setCurrentTrigger("start")) : this.resetAndSetStart(t), this.setHolidaysSelection();
  }
  singleDateSelected(t) {
    this.start = t, this.end = void 0, this.setCurrentTrigger("start"), this.setHolidaysSelection();
  }
  setCurrentTrigger(t) {
    "start" === t ? (this.isSelectingStart = !0, this.isSelectingEnd = !1) : "end" === t ? (this.isSelectingStart = !1, this.isSelectingEnd = !0) : (this.isSelectingStart = !1, this.isSelectingEnd = !1);
  }
  selectEndWithAvailableStart(t) {
    this.start && (t.getTime() < this.start.getTime() || t.getTime() === this.start.getTime() && !this.singleDateSelect) ? this.resetAndSetStart(t) : (this.end = t, this.setCurrentTrigger("start"));
  }
  selectStartWithAvailableEnd(t) {
    this.end && t.getTime() >= this.end.getTime() ? this.resetAndSetStart(t) : (this.start = t, this.setCurrentTrigger("end"));
  }
  selectStartWithSameLengthOfStay(t) {
    const e = new Date(t.getTime() + this.numberOfNights * rt);
    this.lastValidEndDate && this.lastValidEndDate <= e.getTime() || this.isNotFirstTimeSameLength ? this.resetAndSetStart(t) : (this.isNotFirstTimeSameLength = !0, this.end = e, this.start = t, this.setCurrentTrigger("end"));
  }
  resetAndSetStart(t) {
    this.start = t, this.end = void 0, this.setCurrentTrigger("end");
  }
  isDateHolidayEqual(t, e) {
    return this.holidaysConfigured && t.toDateString() === e.toDateString();
  }
  isMonthHolidayEqual(t, e) {
    return !!this.holidaysConfigured && t.getMonth() === e.month && t.getFullYear() === e.year;
  }
  configureHolidays(t) {
    this.dayHolidays = {};
    const e = t.filter(t => t.origin),
      i = JSON.parse(JSON.stringify(t.filter(t => !t.origin))).filter(t => !e.find(e => e.date === t.date && e.name === t.name));
    i.forEach(t => {
      t.name += ` (${t.country})`;
    }), this.holidays = e.concat(i), this.holidays.forEach(t => {
      t.dateSort = new Date(t.date.split("-").join("/")), t.dateSort.setHours(0, 0, 0, 0), t.month = t.dateSort.toLocaleString("default", {
        month: "short"
      }), this.dayHolidays[t.dateSort.toDateString()] = !0;
    }), this.holidays.sort((t, e) => t.dateSort && e.dateSort && (t.dateSort.getTime() > e.dateSort.getTime() || t.dateSort.getTime() === e.dateSort.getTime() && t.origin < e.origin) ? 1 : -1), this.holidaysConfigured = !0, this.setHolidaysSelection();
  }
  setHolidaysSelection() {
    if (this.holidaysConfigured && (this.start || this.end)) {
      const t = new Date(this.start);
      t.setHours(0, 0, 0, 0);
      let e = new Date();
      this.end && (e = new Date(this.end), e.setHours(0, 0, 0, 0)), this.holidaysName = "";
      for (const i of this.holidays) (this.end && i.dateSort && i.dateSort >= t && i.dateSort <= e || !this.end && i.dateSort && i.dateSort.getTime() === t.getTime()) && (this.holidaysName = "" === this.holidaysName ? `${i.month} ${i.dateSort.getDate()}: ${i.name}` : `${this.holidaysName}  •  ${i.month} ${i.dateSort.getDate()}: ${i.name}`);
    } else this.holidaysName = "";
  }
}
var dt = g.Mt,
  ct = g.TY,
  ht = g.cq,
  ut = g.Mk,
  mt = g.D8,
  pt = g.Tc,
  kt = g.gu,
  gt = g.xL,
  Dt = g.Lt,
  St = g.dF,
  yt = g.OE,
  ft = g.al;
export { dt as DatePicker, ct as DatePickerFooterAdditionalText, ht as DatePickerFooterAdditionalTextDialogView, ut as DatePickerFooterAdditionalTextMenuView, mt as DatePickerModel, pt as UitkDateField, kt as UitkDatePickerDateFormat, gt as UitkDatePickerRenderType, Dt as UitkDatePickerTriggeredSelector, St as UitkNewDateField, yt as UitkNewDatePickerDialogView, ft as UitkNewDatePickerMenuView };